import type { FC, ReactNode } from 'react'

import { CalendarDays } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Select } from '@/components/ui/select'
import { semesterLabel, useAcademic } from '@/components/providers/academic-provider'
import { useToast } from '@/components/providers/toast-provider'

type YearSwitcherProps = {
    id: string
    className?: string
}

export const YearSwitcher: FC<YearSwitcherProps> = ({ id, className }): ReactNode => {
    const { data, actions } = useAcademic()
    const toast = useToast()

    if (data.years.length === 0) return null

    const years = [...data.years].sort((a, b) => b.name.localeCompare(a.name) || a.semester.localeCompare(b.semester))

    const handleChange = (yearId: string): void => {
        const result = actions.selectYear(yearId)

        if (result.ok) toast.success(result.message ?? 'Tahun ajaran diganti.')
        else toast.error(result.error)
    }

    return (
        <div className={cn('relative', className)}>
            <label htmlFor={id} className='sr-only'>
                Pilih tahun ajaran
            </label>

            <CalendarDays className='pointer-events-none absolute top-1/2 left-3 z-10 size-4 -translate-y-1/2 text-primary' aria-hidden='true' />

            <Select
                id={id}
                value={data.selectedYearId}
                onChange={event => handleChange(event.target.value)}
                className='h-9 rounded-full pl-9 text-[13px] font-semibold'
                title='Tahun ajaran aktif'
            >
                {years.map(year => (
                    <option key={year.id} value={year.id}>
                        {semesterLabel(year)}
                    </option>
                ))}
            </Select>
        </div>
    )
}
